import React from 'react';
// From https://github.com/oliviertassinari/react-swipeable-views
import SwipeableViews from 'react-swipeable-views';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import {Tabs, Tab} from 'material-ui/Tabs';
import { searchMapICNList, searchMapICNListWithParams } from 'actions/icnActions';
import styles from './styles/CrashDashboardStyles';
import GoogleMapIcnSeverityPinList from 'components/maps/GoogleMapIcnSeverityPinList';
import JasperReport from 'containers/crashDashboard/JasperReport';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';
import SeverityPinLegend from 'components/crashDashboard/severityPinLegend';
import SearchButton from 'containers/search/SearchButton';
import * as settings from 'settings/settings';
import * as cookieServices from 'services/cookies/cookieServices';
import NoResultsBox from 'components/noResults/NoResultsBox';

class CrashDashboard extends React.Component {
    constructor(props){
        super(props);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleSearchICN = this.handleSearchICN.bind(this);
        this.handleClearSearchICN = this.handleClearSearchICN.bind(this);
        this.getInitiaSearchDataValues = this.getInitiaSearchDataValues.bind(this);

        this.state = {
            // tab index
            slideIndex: 0
        };

        /*
            lancio una prima ricerca senza filtri
        */
        var filters = this.getInitiaSearchDataValues(props);
        if(filters){
            this.handleSearchICN(filters);
        }
        else{
            this.props.searchMapICNList();
        }

    }

    /**
     * callback function scatenato da SearchButton
     * @param {filtri definiti dal SearchButton} data
     */
    handleSearchICN(data){
        console.info("handleSearchICN invoked!!");
        console.info(data);
        console.info(this.props.isSearching);
        if(this.state.isSearching) return;

        this.props.searchMapICNListWithParams(data);
    }

    /**
     * callback function scatenato da SearchButton
     */
    handleClearSearchICN(){
        console.info("handleClearSearchICN invoked!!");
        this.props.searchMapICNList();
    }

    /**
     * gestione cambio tab
     */
    handleTabChange = (value) => {
        this.setState({
          slideIndex: value,
        });
    };

    getInitiaSearchDataValues(props){

        var savedFilters = cookieServices.getSeachFilters();

        if(savedFilters)
        {
            return {
                icnId: savedFilters.icnId,
                vin: savedFilters.vin,
                deviceFilterValue: savedFilters.deviceFilterValue,
                dateFrom: new Date(savedFilters.dateFrom),
                dateTo: new Date(savedFilters.dateTo),
                severityCodeList: props.severityCodeList,
                selectedSeverityValues: savedFilters.selectedSeverityValues,
                eventClassificationList: props.eventClassificationList,
                selectedClassificationValue: savedFilters.selectedClassificationValue,
                selectedDeviceIdType: savedFilters.selectedDeviceIdType,
                includeSubAccount: savedFilters.includeSubAccount,
                selectedAccount: savedFilters.selectedAccount
            }
        }
        return null;
    }

    render() {
        console.info("CrashDashboard page rendered");
        var { translate, currentLanguage, mapList, isSearching, isMilesPerHour } = this.props;

        return (
            <div style={{minWidth: 300}} >
                <Tabs
                    inkBarStyle={styles.inkBarStyle}
                    style={styles.tabsHeader}
                    onChange={this.handleTabChange}
                    value={this.state.slideIndex}
                    >
                    <Tab style={styles.tabHeader} label={translate('CrashDashboard.mainCharts')} value={0} />
                    <Tab style={styles.tabHeader} label={translate('CrashDashboard.worldChart')} value={1} />
                </Tabs>
                <SwipeableViews
                    index={this.state.slideIndex}
                    onChangeIndex={this.handleTabChange}
                    >
                    <div style={styles.slide}>
                        <JasperReport />
                    </div>
                    <div style={styles.slide}>
                        {
                            isSearching?
                            <SpinnerLoaderWithText />
                            :
                            <div>
                                <div style={{marginBottom: 10}}>
                                    <SearchButton searchCallBack={this.handleSearchICN} searchClearCallBack={this.handleClearSearchICN} fullWidth={true}  ></SearchButton>
                                </div>
                                {
                                    mapList && mapList.length > 0  ?
                                    <GoogleMapIcnSeverityPinList icnList={mapList} translate={translate} currentLanguage={currentLanguage} isMilesPerHour={isMilesPerHour}
                                        googleMapURL={settings.googleMapUrl}
                                        loadingElement={<div style={{ height: `100%` }} />}
                                        containerElement={<div style={{ height: `600px` }} />}
                                        mapElement={<div style={{ height: `100%` }} />} />
                                    : <NoResultsBox />
                                }
                            </div>

                        }

                    <SeverityPinLegend />

                    </div>

                </SwipeableViews>
            </div>
        );
    }
}

CrashDashboard.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){

    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        mapList: state.icnSearch.mapList,
        mapTotalCount: state.icnSearch.mapTotalCount,
        isSearching: state.icnSearch.isSearching,
        isMilesPerHour: state.systemUnitsSearch.item ? state.systemUnitsSearch.item.isMilesPerHour : false,
        severityCodeList: state.appData.severityCodeListForDropDown,
        eventClassificationList: state.appData.eventClassificationListForDropDown
    }
}
export default connect(mapStateToProps, {searchMapICNList, searchMapICNListWithParams})(CrashDashboard);


// WEBPACK FOOTER //
// ./src/containers/crashDashboard/CrashDashboard.js